<template>
  <div class="cs-offerWallContainer" v-if="dictionary && filters">
    <OfferWallFiltersComponent :filters="filters" :dictionary="dictionary" v-if="!!dictionary" @updateFilters="updateOffers"></OfferWallFiltersComponent>
    <div class="cs-offerWall__offers" v-if="offersCount > 0 ">
      <OfferWallItemComponent v-for=" item in offers" v-bind:key="item._id" 
      :offerWallItemInfo="item" :dictionary="dictionary" :shouldOpenModal="hasModalToBeOpened(item._id)" 
      @offerEnded="onOfferEnd" @offerStarted="onOfferStart"></OfferWallItemComponent>
    </div>
  </div>
  </template>
  
  <script>
  import axios from "axios";
  import OfferWallItemComponent from "./OfferWallItemComponent.vue";
  import OfferWallFiltersComponent from "./OfferWallFiltersComponent.vue";
  import { API2 } from '@/assets/js/constants';
  export default {
    name: 'OfferWallComponent',
    components: {OfferWallItemComponent, OfferWallFiltersComponent },
    data: function(){
      return{
        activeOffers: [],
        futureOffers: [],
        offersCount: 0,
        filters: {},
        dictionary: null,
      }
    },
    methods: {
      updateOffers(selectedFilters){
        axios.post( API2.url + API2.offersTimed, {
        // eslint-disable-next-line no-undef
        "lang": currentLanguage,
        selectedFilters
      }).then(
      (res) => {
          this.offers = res.data.offers;
          this.offersCount = res.data.offersCount;
          }
        );
      },
      hasModalToBeOpened(currentOfferID){
        let urlParams = new URLSearchParams(window.location.search);
        if(urlParams.has('offerID')){
          return urlParams.get('offerID') == currentOfferID;
        }
      },
      onOfferEnd(offer){
        this.offers = this.offers.filter(offerItem => offerItem._id != offer._id);
        this.offersCount = this.offersCount - 1;
        console.log('onOfferEnd');
      },
      onOfferStart(offer){
        this.offers.find(offerItem => offerItem._id == offer._id).status = "active";
      }
    },
    mounted: function() {
     axios.post( API2.url + API2.offersTimed, {
      // eslint-disable-next-line no-undef
      "lang": currentLanguage,
     }).then(
      (res) => {
          this.offers = res.data.offers;
          this.offersCount = res.data.offersCount;
          }
        );
      axios.get(API2.url + API2.offersFilters, {
      // eslint-disable-next-line no-undef
      "lang": currentLanguage,
      }).then(
        (res) => {
          this.filters = res.data;
        }
      );
      // eslint-disable-next-line no-undef
      axios.get('https://comprasocial.me/wp-content/themes/cs-theme/assets/cs-offerwall/dictionary-' + currentLanguage + '.json').then(
        (res) => {
          this.dictionary = res.data;
        }
      );
      
    }

    
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style lang="scss" scoped>
  // @import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;1,400&display=swap');
  .cs-offerWall {
    &Container {
      margin: 0 auto;
      font-family: 'Poppins', sans-serif;
    }

    &__offers{
      display: grid;
      grid-template-columns: 1fr 1fr;

      @media screen and (min-width: 768px) {
        grid-template-columns: repeat(5, 1fr);
      }
    }
  }
  </style>
  